module.exports = __webpack_public_path__ + "30e02851c478dfe39c7c8efad20bdbc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./photo.jpg
// module id = 497
// module chunks = 0